import axios from 'axios';

import i18n from '../i18n';

export const ACCOUNT_DATA_UPDATED_EVENT = 'accountDataUpdated';

export function getMyAccountData(callback, errorcallback) {
  axios
    .get('/account/get_account_data')
    .then((response) => {
      if (response.status == 200) {
        var accountData = response.data.accountData;
        i18n.changeLanguage(accountData?.communication_language.toLowerCase());
        // Sync localStorage so MainNavbar and other components see fresh data
        if (accountData) {
          const existing = JSON.parse(
            localStorage.getItem('AccountData') || '{}',
          );
          localStorage.setItem(
            'AccountData',
            JSON.stringify({ ...existing, ...accountData }),
          );
          window.dispatchEvent(new CustomEvent(ACCOUNT_DATA_UPDATED_EVENT));
        }
        callback(accountData);
      }
    })
    .catch((err) => {
      errorcallback(err);
    });
}

export function getMyAccount(callback, errorcallback) {
  axios
    .get('/account/get_my_account')
    .then((response) => {
      if (response.status == 200) {
        callback(response.data);
      }
    })
    .catch((err) => {
      errorcallback(err);
    });
}

export function getPublicAccountInfo(account_id, callback, errorcallback) {
  axios
    .get(`/account/get_public_account_info?account_id=${account_id}`)
    .then((response) => {
      if (response.status == 200) {
        callback(response.data);
      }
    })
    .catch((err) => {
      errorcallback(err);
    });
}

export function getAccountDataByToken(token, callback, errorcallback) {
  axios
    .get(`/account/get_by_token?token=${token}`)
    .then((response) => {
      if (response.status == 200) {
        var accountData = response.data;
        callback(accountData);
      }
    })
    .catch((err) => {
      errorcallback(err);
    });
}

export function getAccountDataByPasswordResetToken(
  token,
  callback,
  errorcallback,
) {
  axios
    .get(`/account/find_by_password_reset_token?token=${token}`)
    .then((response) => {
      if (response.status == 200) {
        var accountData = response.data;
        callback(accountData);
      }
    })
    .catch((err) => {
      errorcallback(err);
    });
}

export function getMyBankAccountData(callback, errorcallback) {
  axios
    .get('/account/get_account_data')
    .then((response) => {
      if (response.status == 200) {
        var bankaccountData = response.data.bankaccountData;
        callback(bankaccountData);
      }
    })
    .catch((err) => {
      errorcallback(err);
    });
}

export function updateBankAccountData(
  bankAccountData,
  callback,
  errorcallback,
) {
  console.log('updateBankAccountData', bankAccountData);
  axios
    .post('account/update_bankaccount_data', bankAccountData)
    .then((response) => {
      if (response.status == 200) {
        callback(response.data);
      }
    })
    .catch((err) => {
      errorcallback(err);
    });
}

export const updateAccountData = (accountData, callback, errorcallback) => {
  i18n.changeLanguage(accountData.communication_language.toLowerCase());
  axios
    .post('account/update_account_data', accountData)
    .then((response) => {
      if (response.status == 200) {
        // Sync localStorage so MainNavbar reflects changes (e.g. show_badge_management)
        const existing = JSON.parse(
          localStorage.getItem('AccountData') || '{}',
        );
        localStorage.setItem(
          'AccountData',
          JSON.stringify({ ...existing, ...accountData }),
        );
        window.dispatchEvent(new CustomEvent(ACCOUNT_DATA_UPDATED_EVENT));
        callback(response.data);
      }
    })
    .catch((err) => {
      errorcallback(err);
    });
};

export const checkIfEmailExists = (email, callback, errorcallback) => {
  axios
    .post(`account/check_if_email_exists?email=${email}`)
    .then((response) => {
      if (response.status == 200) {
        callback(response.data);
      }
    })
    .catch((err) => {
      errorcallback(err);
    });
};
